import ng_en_US from '@angular/common/locales/en';
import ng_fr_FR from '@angular/common/locales/fr';
import { fr_FR, en_US } from 'ng-zorro-antd/i18n';
import { CwtDeepPartial, ICwtCoreConfig } from '@cawita/core-front';
import * as models from '@shared/models';
import { environment } from '../../environments/environment';
import { CwtDefaultAuthConfig } from '@cawita/core-front/auth';

export const CwtAdminCoreConfig: CwtDeepPartial<ICwtCoreConfig> = {
    api: {
        apiUrl: environment.apiUrl,
        models: Object.values(models) as any[],
    },
    asset: {
        assetUrl: environment.assetUrl,
        protectedAssetPath: environment.protectedAssetPath,
        publicAssetPath: environment.publicAssetPath,
    },
    auth: {
        stateStorageKey: 'cwt-admin-auth',
        api: {
            ...CwtDefaultAuthConfig?.api,
            registerEndpoint: 'user/subscribe'
        },
        navigation: {
            defaultRoute: ['/'],
            permissionDeniedRoute: ['/'],
            loginRoute: ['/auth', 'login'],
        },
    },
    i18n: {
        currentLocaleStorageKey: 'cwt-admin-locale',
        defaultCurrencyCode: 'EUR',
        defaultLocale: 'fr',
        locales: [
            { localeId: 'fr', localeName: 'Français', ngLocaleData: ng_fr_FR, extra: { nzLocaleData: fr_FR } },
            { localeId: 'en', localeName: 'English', ngLocaleData: ng_en_US, extra: { nzLocaleData: en_US } },
        ],
        resources: [
            { prefix: '/assets/i18n/', suffix: '.json' },
            { prefix: '/assets/i18n/', suffix: '.errors.json', key: 'errors' },
        ]
    }
}